import { useState } from 'react';

export function useAsyncAction<Args extends unknown[], R>(action: (...args: Args) => Promise<R>) {
    const [pending, setPending] = useState(false);

    const run = async (...args: Args): Promise<R> => {
        setPending(true);
        try {
            const result = await action(...args);
            return result;
        } finally {
            setPending(false);
        }
    };

    return { pending, run };
}
